let download = {
  title:"Rabbit VPN支持多个平台上的设备",
  explain: "选择您的平台并启用RabbitVPN以保护您的隐私和安全",
  system: {
    windows: "微软",
    macOS: "Mac",
    android: "安卓",
    iOS: "苹果"
  },
  eqDesp: "扫描二维码下载",
  second_title: {
    title_1: "将您的隐私",
    title_2: "放在首位的VPN应用",
    title_3: "程序"
  },
  description: "我们的应用程序旨在保护您的互联网连接安全和隐私，防止您的ISP和"
    + "政府不会监视你和你访问的网站，不会识别和跟踪你，也不会殴打你"
    + "+审查制度，为所有人提供免费和开放的互联网。",
  download_btn: "下载Rabbit VPN",
  download_title: "简单快速的VPN",
  download_desp: "免费VPN，无需电子邮件即可快速使用",
  content: {
    download: "下载",
    install: "安装",
    enable: "启用VPN",
    use: "使用"
  }
}
export default download


// WEBPACK FOOTER //
// ./src/assets/lang/zh/new_download/index.js